import { on, createReducer, Action } from '@ngrx/store';
import { ICart, IAddress, ICoupon } from '@care-portals/api-interfaces';
import * as CheckoutActions from './checkout.actions';

export const FEATURE_KEY = 'checkout';

export interface State {
  cart: ICart;
  error: Error;
  loading: boolean;
  saving: boolean;
  orderId: number;
  addresses: IAddress[];
  coupon: ICoupon;
  orderItems: Array<any>;
}

const initialState: State = {
  cart: null,
  error: null,
  loading: true,
  saving: false,
  orderId: null,
  addresses: [],
  coupon: null,
  orderItems: []
};

const _reducer = createReducer(
  { ...initialState },

  on(CheckoutActions.loadCart, (state: State, { cartId }) => {
    return {
      ...state,
      error: null,
      loading: true
    };
  }),

  on(CheckoutActions.loadCartSuccess, (state: State, { cart }) => {
    return {
      ...state,
      cart: cart,
      error: null,
      loading: false
    };
  }),

  on(CheckoutActions.loadCartFailure, (state: State, { error }) => {
    return {
      ...state,
      error: error,
      cart: null,
      loading: false
    };
  }),

  on(CheckoutActions.createOrder, (state: State, { newOrder }) => {
    return {
      ...state,
      error: null,
      loading: true
    };
  }),

  on(CheckoutActions.createOrderSuccess, (state: State, { orderId }) => {
    return {
      ...state,
      error: null,
      orderId: orderId,
      loading: false
    };
  }),

  on(CheckoutActions.createOrderFailure, (state: State, { error }) => {
    return {
      ...state,
      error: error,
      loading: false
    };
  }),

  on(CheckoutActions.applyCoupon, (state: State) => {
    return {
      ...state,
      coupon: null
    };
  }),

  on(CheckoutActions.applyCouponSuccess, (state: State, { coupon }) => {
    return {
      ...state,
      coupon
    };
  }),

  on(CheckoutActions.applyCouponFailure, (state: State, { error }) => {
    return {
      ...state,
      coupon: null,
      error: error
    };
  }),

  // on(CheckoutActions.setShippingAddress, (state: State) => {
  //   return {
  //     ...state,
  //     error: null,
  //     saving: true
  //   };
  // }),

  // on(CheckoutActions.setShippingAddressSuccess, (state: State, { res }) => {
  //   return {
  //     ...state,
  //     saving: false
  //   };
  // }),

  // on(CheckoutActions.setShippingAddressFailure, (state: State, { error }) => {
  //   return {
  //     ...state,
  //     error: error,
  //     saving: false
  //   };
  // }),

  on(CheckoutActions.loadAddresses, (state: State) => {
    return {
      ...state,
      addresses: [],
      error: null,
      loading: true
    };
  }),

  on(CheckoutActions.loadAddressesSuccess, (state: State, { addresses }) => {
    return {
      ...state,
      addresses,
      loading: false
    };
  }),

  on(CheckoutActions.loadAddressesFailure, (state: State, { error }) => {
    return {
      ...state,
      error: error,
      loading: false
    };
  }),

  on(CheckoutActions.setOrderItemsSuccess, (state: State, { orderItems }) => {
    return {
      ...state,
      orderItems
    };
  })

  // on(CheckoutActions.saveAddresses, (state: State) => {
  //   return {
  //     ...state,
  //     error: null,
  //     saving: true
  //   };
  // }),

  // on(CheckoutActions.saveAddressesSuccess, (state: State, { addresses }) => {
  //   return {
  //     ...state,
  //     addresses,
  //     saving: false
  //   };
  // }),

  // on(CheckoutActions.saveAddressesFailure, (state: State, { error }) => {
  //   return {
  //     ...state,
  //     error: error,
  //     saving: false
  //   };
  // })
);

export function reducer(state: State | undefined, action: Action) {
  return _reducer(state, action);
}
